<template>
  <div>
    <el-tabs v-model="accountFlag" @tab-click="search" v-if="[0, 1, 10].includes($store.state.userInfo.userType)">
      <el-tab-pane label="开卡推广员小程序" name="extend"></el-tab-pane>
      <el-tab-pane label="银行经理小程序" name="bank"></el-tab-pane>
    </el-tabs>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-width="85px" label-position="left">
        <el-form-item label="申请时间">
          <date-range-picker :value="createTime" @getChange="value => createTime = value"></date-range-picker>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.mobile" placeholder="请输入手机号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item v-show="accountFlag === 'extend'" label="代理商编号" v-if="[0, 1, 2].includes(this.$store.state.userInfo.userType)">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item v-show="accountFlag === 'bank'" label="银行编号">
          <el-input v-model="searchForm.bankCode" placeholder="请输入银行编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="searchForm.realName" placeholder="请输入姓名" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="searchForm.status" :clearable="true">
            <el-option v-for="item in statusList" :label="item.text" :value="item.status" :key="item.status"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
      </el-form>
    </module-card>
    <module-card title="小程序账号审核">
      <el-table class="table" border :data="list" v-loading="searchLoading">
        <el-table-column
          label="申请时间"
          width="100"
          prop="applyTime"
          key="applyTime">
        </el-table-column>
        <el-table-column
          label="微信名"
          prop="wxNickname"
          v-if="accountFlag === 'extend'"
          key="wxNickname">
        </el-table-column>
        <el-table-column
          label="姓名"
          prop="realName"
          key="realName">
        </el-table-column>
        <el-table-column
          label="工号"
          prop="managerNo"
          v-if="accountFlag === 'bank'">
        </el-table-column>
        <el-table-column
          label="推广员编号"
          prop="userValue"
          v-if="accountFlag === 'extend'"
          key="userValue">
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="mobile"
          key="mobile">
        </el-table-column>
        <el-table-column
          label="乐刷编号"
          prop="managerId"
          v-if="accountFlag === 'bank'"></el-table-column>
        <el-table-column
          label="代理商编号"
          prop="agentId"
          v-if="accountFlag === 'extend'"
          key="agentId">
        </el-table-column>
        <el-table-column
          label="代理商名称"
          prop="agentName"
          v-if="accountFlag === 'extend'"
          key="agentName">
        </el-table-column>
        <el-table-column
          label="银行编号"
          prop="newCode"
          v-if="accountFlag === 'bank'"
          key="newCode">
        </el-table-column>
        <el-table-column
          label="银行名称"
          prop="bankCodeName"
          v-if="accountFlag === 'bank'"
          key="bankCodeName">
        </el-table-column>
        <el-table-column
          label="审核状态"
          prop="status"
          key="status">
          <template slot-scope="scope">
            <span>{{getStatusText(scope.row.status)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="审核时间"
          width="100"
          prop="checkTime"
          key="checkTime">
          <template slot-scope="scope">
            <span>{{scope.row.status === 10 ? '' : scope.row.checkTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="审核人"
          prop="checker"
          key="checker">
        </el-table-column>
        <el-table-column
          label="操作"
          width="160">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 10" class="flex-space-between">
              <auth-button auth-type="span" opt="check_pass" label="通过" class="editBtn" @click.native="handlerStatus(scope.row, '0')"></auth-button>
              <auth-button auth-type="span" opt="check_no_pass" label="不通过" class="editBtn" @click.native="handlerStatus(scope.row, '20')"></auth-button>
              <!-- <auth-button auth-type="span" opt="check_black" label="黑名单" class="editBtn" @click.native="handlerStatus(scope.row, '30')"></auth-button> -->
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="searchForm.pageNo" :size="searchForm.pageSize" @changePage="value => { searchForm.pageNo = value;getList() }"></pagination>
    </module-card>
    <dialog-info :title="'是否确认审核【' + typeText + '】'" :visible.sync="showAuthDialog" :confirmLoading="authLoading" @confirm="submitAuth">
      <div class="accountMsg">
        <p><span>微信名</span>{{editMsg.wxNickname}}</p>
        <p><span>姓名</span>{{editMsg.realName}}</p>
        <p><span>手机号</span>{{editMsg.mobile}}</p>
        <p v-show="accountFlag === 'extend'"><span>代理商编号</span>{{editMsg.agentId}}</p>
        <p v-show="accountFlag === 'extend'"><span>代理商名称</span>{{editMsg.agentName}}</p>
        <p v-show="accountFlag === 'bank'"><span>银行编号</span>{{editMsg.newCode}}</p>
        <p v-show="accountFlag === 'bank'"><span>银行名称</span>{{editMsg.bankCodeName}}</p>
      </div>
    </dialog-info>
  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
export default {
  name: 'miniAuthAccount',
  components: {
    dialogInfo,
    dateRangePicker,
    pagination
  },
  data () {
    return {
      searchForm: {
        mobile: '',
        realName: '',
        agentId: '',
        replyStartTime: '',
        replyEndTime: '',
        status: '',
        pageNo: 1,
        pageSize: 10,
        count: 0,
        statusList: [],
        bankCode: ''
      },
      total: 0,
      createTime: [],
      statusList: [
        {
          text: '待审核',
          status: '10'
        },
        {
          text: '审核通过',
          status: '0'
        },
        {
          text: '审核不通过',
          status: '20'
        }
        // {
        //   text: '黑名单',
        //   status: '30'
        // }
      ],
      searchLoading: false,
      showAuthDialog: false,
      authLoading: false,
      editType: '0',
      list: [],
      editMsg: {},
      accountFlag: 'extend'
    }
  },
  computed: {
    typeText () {
      const that = this
      return this.statusList.filter(item => {
        return item.status === that.editType
      })[0].text
    }
  },
  mounted () {
    if (this.$store.state.userInfo.userType === 4) {
      this.accountFlag = 'bank'
    }
    this.getList()
  },
  methods: {
    search () {
      this.searchForm.pageNo = 1
      this.getList()
    },
    getList () {
      const type = this.accountFlag
      const urlApi = this.accountFlag === 'extend' ? 'miniAcountList' : 'bankMiniAcountList'
      this.searchLoading = true
      this.searchForm.replyStartTime = this.createTime[0] || ''
      this.searchForm.replyEndTime = this.createTime[1] || ''
      this.searchForm.statusList = this.searchForm.status !== '' ? [this.searchForm.status] : []
      this.$axios.post(this.$api[urlApi], this.searchForm).then(res => {
        this.searchLoading = false
        if (res.respCode === '0' && type === this.accountFlag) {
          this.list = res.data.list
          this.total = res.data.count
        }
      })
    },
    handlerStatus (row, type) {
      this.editType = type
      this.showAuthDialog = true
      this.editMsg = row
    },
    submitAuth () {
      const urlApi = this.accountFlag === 'extend' ? 'checkMiniAccount' : 'checkBankMiniAccount'
      this.$axios.post(this.$api[urlApi], {
        userId: this.editMsg.userId,
        status: this.editType
      }).then(res => {
        if (res.respCode === '0') {
          this.showAuthDialog = false
          this.$message({
            type: 'success',
            message: '修改状态成功'
          })
          this.getList()
        }
      })
    },
    getStatusText (status) {
      const result = this.statusList.filter(item => {
        return item.status === status + ''
      })
      if (result.length === 1) {
        return result[0].text
      } else {
        return '未知'
      }
    }
  }
}
</script>
<style lang="less">
.accountMsg{
  padding-top: 14px;
  p{
    font-size: 16px;
    color: #333;
    line-height: 16px;
    margin-bottom: 25px;
    span{
      width: 100px;
      display: inline-block;
    }
  }
}
</style>
